import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {MilestoneRow$key} from './__generated__/MilestoneRow.graphql'
import {MilestoneDate} from './MilestoneDate'
import {MilestoneIssueCount} from './MilestoneIssueCount'
import {MilestoneRowMetadata, type MilestoneRowMetadataFragment} from './MilestoneRowMetadata'
import {MilestoneRowTitle} from './MilestoneRowTitle'
import styles from './RepositoryMilestone.module.css'

type MilestoneRowProps = {
  milestone: MilestoneRow$key
  repositoryNameWithOwner: string
}

export function MilestoneRow({milestone, repositoryNameWithOwner}: MilestoneRowProps) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment MilestoneRow on Milestone {
        closed
        description
        dueOn
        id
        title
        url
        closedIssueCount
        openIssueCount
        state
        repository {
          id
          viewerCanPush
        }
        progressPercentage
      }
    `,
    milestone,
  )

  const title = <MilestoneRowTitle milestone={data} />
  // RELAY-CLEANUP(MilestoneRow): open-enum `state` cast. Remove when MilestoneRow leaves Relay.
  const metadata = (
    <MilestoneRowMetadata
      milestone={data as MilestoneRowMetadataFragment}
      repositoryNameWithOwner={repositoryNameWithOwner}
    />
  )

  return (
    <ListItem
      key={data.id}
      title={title}
      role="listitem"
      metadata={metadata}
      className={styles.milestoneRow}
      metadataContainerClassName={styles.listMetadataContainer}
    >
      <ListItemMainContent>
        <ListItemDescription className={styles.listItemContent}>
          {data.description && <p className={styles.listDescription}>{data.description}</p>}
          <div className={styles.listDateContainer}>
            <MilestoneDate milestone={data} />
            <MilestoneIssueCount milestone={data} />
          </div>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}
